// Small colour helpers shared by the game components (hex in, css out).
export function hexToRgb(hex) {
  const h = String(hex || "").replace("#", "");
  const v = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  const n = parseInt(v, 16);
  if (v.length !== 6 || Number.isNaN(n)) return [168, 85, 247];
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

// amt > 0 → toward white, amt < 0 → toward black
export function mix(hex, amt) {
  const [r, g, b] = hexToRgb(hex);
  const target = amt < 0 ? 0 : 255;
  const k = Math.min(1, Math.abs(amt));
  const f = (c) => Math.round(c + (target - c) * k);
  return `rgb(${f(r)}, ${f(g)}, ${f(b)})`;
}

export function alpha(hex, a) {
  const [r, g, b] = hexToRgb(hex);
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}
